import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../tailwind.config.js';

const twConfig = resolveConfig(tailwindConfig);

export default twConfig;
